import React, { Component } from "react";
import { CardBody, Card, Label, Col, Button, Row } from "reactstrap";
import './style.css'
import { Preloading } from '../../components/UI/Preloader/action';
import { connect } from "react-redux";
import { addCorporateBillingMasterUpload, corporateBillingMasterTemplateRequest, corporateBillingMasterDataExcelRequest } from "./action";
import { toast } from 'react-toastify';
import fileSaver from 'file-saver';


class CorporateBillingMasterUploadUtility extends Component {
  constructor(props) {
    super(props);
    this.state = {
      type: "",
      corporateBillingMasterExcelFile: '',
      noExcelUploadWarning: '',
    };
  }

  componentDidUpdate(prevProps) {

    if (this.props.corporateBillingMasterTemplateSuccess !== prevProps.corporateBillingMasterTemplateSuccess) {
      this.props.preloading(false)
      var blob = new Blob([this.props.corporateBillingMasterTemplateSuccess.data], { type: 'application/octet-stream' });
      fileSaver.saveAs(blob, `Corporate_Billing_Master_Template.xlsx`);
      toast.success(
        <div>
          <i className="fa fa-check-circle fa-lg"></i>&nbsp;File Downloaded Successfully
        </div>
      );
    }
    if (this.props.corporateBillingMasterTemplateFailure !== prevProps.corporateBillingMasterTemplateFailure) {
      this.props.preloading(false)
      toast.error(
        <div>
          <i className="fa fa-exclamation-triangle"></i>&nbsp;Some error occured<br />&nbsp;Please try again!
        </div>
      );
    }

    if (this.props.corporateBillingMasterDataExcelSuccess !== prevProps.corporateBillingMasterDataExcelSuccess) {
      this.props.preloading(false)
      var blob = new Blob([this.props.corporateBillingMasterDataExcelSuccess.data], { type: 'application/octet-stream' });
      fileSaver.saveAs(blob, `Corporate_Billing_Master_Data.xlsx`);
      toast.success(
        <div>
          <i className="fa fa-check-circle fa-lg"></i>&nbsp;File Downloaded Successfully
        </div>
      );
    }
    if (this.props.corporateBillingMasterDataExcelFailure !== prevProps.corporateBillingMasterDataExcelFailure) {
      this.props.preloading(false)
      toast.error(
        <div>
          <i className="fa fa-exclamation-triangle"></i>&nbsp;Some error occured<br />&nbsp;Please try again!
        </div>
      );
    }

    if (this.props.addCorporateBillingMasterUploadSuccess !== prevProps.addCorporateBillingMasterUploadSuccess) {
      this.props.preloading(false)
      const successMessage = this.props.addCorporateBillingMasterUploadSuccess?.message || 
                             this.props.addCorporateBillingMasterUploadSuccess?.data?.message || 
                             this.props.addCorporateBillingMasterUploadSuccess?.data || 
                             'Upload successful';
      toast.success(
        <div>
          <i className="fa fa-check-circle fa-lg"></i>&nbsp; {successMessage}
        </div>
      );
      setTimeout(() => {
        window.location.reload();
      }, 1500);
    }
    if (this.props.addCorporateBillingMasterUploadFailure !== prevProps.addCorporateBillingMasterUploadFailure) {
      this.props.preloading(false)
      const errorMessage = this.props.addCorporateBillingMasterUploadFailure?.data?.data || 
                           this.props.addCorporateBillingMasterUploadFailure?.data?.message || 
                           this.props.addCorporateBillingMasterUploadFailure?.data || 
                           'Upload failed';
      toast.error(
        <div>
          <i className="fa fa-exclamation-triangle fa-lg"></i>&nbsp; {errorMessage}
        </div>
      );
    }

    if (this.props.addCorporateBillingMasterUploadFailureFile && this.props.addCorporateBillingMasterUploadFailureFile !== prevProps.addCorporateBillingMasterUploadFailureFile) {
      this.props.preloading(false)
      var blob = new Blob([this.props.addCorporateBillingMasterUploadFailureFile], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      fileSaver.saveAs(blob, "Corporate_Billing_Master_Errors.xlsx");
      toast.error(
        <div>
          <i className="fa fa-exclamation-triangle fa-lg"></i>&nbsp; Upload failed. Please check the downloaded error file for details.
        </div>
      );
    }
  }

  handleTemplateDownload = () => {
    this.props.preloading(true)
    this.props.corporateBillingMasterTemplateRequest();
  }

  handleDownloadCorporateBillingData = () => {
    this.props.preloading(true)
    this.props.corporateBillingMasterDataExcelRequest();
  }

  uploadExcel = (event) => {
    this.setState({
      corporateBillingMasterExcelFile: event.target.files[0]
    })
    event.preventDefault();
    event.target.value = null;
  }

  handleSubmit = () => {
    if (!this.state.corporateBillingMasterExcelFile) {
      this.setState({ noExcelUploadWarning: '*Please upload the filled request template!' })
    }
    if (this.state.type === '') {
      toast.error(
        <div>
          <i className="fa fa-exclamation-triangle"></i>&nbsp;Please Select Upload Type
        </div>
      );
    }

    else {
      this.props.addCorporateBillingMasterUpload({ file: this.state.corporateBillingMasterExcelFile, type: this.state.type });
      this.props.preloading(true);
    }
  }

  render() {
    return (
      <Col>
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h4 className="mb-0 text-center">Corporate Billing Master</h4>
        </div>
        <Card>
          <CardBody>
            <Label>Upload Corporate Billing Master Template</Label>
            <Row>
              <Col sm="22">
                <Button
                  color="primary"
                  onClick={this.handleTemplateDownload}
                  className="btn color-excel-download "
                >
                  <i className="fa fa-file-excel-o fa-lg"></i>
                  &nbsp;&nbsp;Download Template
                </Button>
                <Row
                  color="primary"
                  className="btn btn-primary ml-0 position-relative excel-upload-btn browse-files ml-3"
                  title="Upload Request Template"
                >
                  <input
                    onChange={this.uploadExcel}
                    type="file"
                    name="file"
                    id="file"
                    className="upload-file"
                    title="Upload Request Template"
                    accept=".xlsx"
                  />
                  <i className="fa fa-paperclip color-888 rotate-90deg p-1 fa-lg" />{" "}
                  Upload Template
                </Row>
                <Label className="uploadType">Upload Type : </Label>
                <div className="corporateBillingType">
                  <input name="type" type="radio" value="add" onChange={e => { this.setState({ type: e.target.value }) }} />
                  &nbsp;&nbsp;Add New Records
                  <label>
                    <input name="type" type="radio" value="edit" onChange={e => { this.setState({ type: e.target.value }) }} />
                    &nbsp;&nbsp;Update Existing
                  </label>
                </div>
                <Button
                  className="ml-5"
                  color="primary"
                  onClick={this.handleSubmit}
                >
                  Submit
                </Button>
                <Button className="ml-5"
                  color="success" onClick={this.handleDownloadCorporateBillingData}>Download Existing Data</Button>
                <Row className={(this.state.corporateBillingMasterExcelFile) ? "text-muted ml-1 transaction-file-name-text" : "text-danger ml-1 noUploadWarning-text"}>{(this.state.corporateBillingMasterExcelFile) ? this.state.corporateBillingMasterExcelFile.name : this.state.noExcelUploadWarning}</Row>
                

              </Col>
            </Row>
          </CardBody>
        </Card>

      </Col>
    );
  }
}



const mapStateToProps = (state, ownProps) => ({
  corporateBillingMasterTemplateSuccess: state.corporateBillingMasterReducer.corporateBillingMasterTemplateSuccess,
  corporateBillingMasterTemplateFailure: state.corporateBillingMasterReducer.corporateBillingMasterTemplateFailure,
  addCorporateBillingMasterUploadSuccess: state.corporateBillingMasterReducer.addCorporateBillingMasterUploadSuccess,
  addCorporateBillingMasterUploadFailure: state.corporateBillingMasterReducer.addCorporateBillingMasterUploadFailure,
  addCorporateBillingMasterUploadFailureFile: state.corporateBillingMasterReducer.addCorporateBillingMasterUploadFailureFile,
  corporateBillingMasterDataExcelSuccess: state.corporateBillingMasterReducer.corporateBillingMasterDataExcelSuccess,
  corporateBillingMasterDataExcelFailure: state.corporateBillingMasterReducer.corporateBillingMasterDataExcelFailure,
})

const mapDispatchToProps = (dispatch, ownProps) => ({
  preloading: (isPreloading) => { dispatch(Preloading(isPreloading)); },
  corporateBillingMasterTemplateRequest: () => dispatch(corporateBillingMasterTemplateRequest()),
  corporateBillingMasterDataExcelRequest: () => dispatch(corporateBillingMasterDataExcelRequest()),
  addCorporateBillingMasterUpload: (data) => dispatch(addCorporateBillingMasterUpload(data)),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CorporateBillingMasterUploadUtility);
